import { IDocumentMetadata } from "contracts/documents";
import { DataConverter } from "../../../Global/Base/Converters/DataConverter";
import { ISignatureDataStream } from "../CryptoInterfaces";

/**
 * Stream z řetězce
 */
export class StringSignatureStream implements ISignatureDataStream {
    private readonly _data: string;
    private readonly _name: string;
    private readonly _referenceUri: string;

    /**
     * Vytvoří stream z řetězce
     */
    constructor(data: string, name: string, referenceUri: string) {
        this._data = data;
        this._name = name;
        this._referenceUri = referenceUri;
    }

    public async read(chunkSize: number, onChunkDownloaded: (chunk: ArrayBuffer, isLastChunk: boolean) => Promise<void>): Promise<void> {
        const objDataByteArray = DataConverter.base64ToArray(DataConverter.btoaUtf8(this._data));
        const arrayLength = objDataByteArray.length;

        for (let chunkStart = 0; chunkStart < arrayLength; chunkStart += chunkSize) {
            const chunkEnd = chunkStart + chunkSize;
            const isLastChunk = chunkEnd >= arrayLength;
            const chunk = objDataByteArray.slice(chunkStart, chunkEnd);
            await onChunkDownloaded(chunk.buffer, isLastChunk);
        }
    }

    public getName(): Promise<string> {
        return Promise.resolve(this._name);
    }

    public getMetadata(): Promise<IDocumentMetadata | null> {
        return Promise.resolve(null);
    }

    public getReferenceUri(): Promise<string> {
        return Promise.resolve(this._referenceUri);
    }
}
